import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// ✅ Firebase configuration (Hardcoded)
const firebaseConfig = {
  apiKey: "AIzaSyAB223pYGDwjHZGLZ_b3YeHQJZFnRtqT5M",
  authDomain: "duitaichatbot.firebaseapp.com",
  projectId: "duitaichatbot",
  storageBucket: "duitaichatbot.firebasestorage.app",
  messagingSenderId: "627044639783",
  appId: "1:627044639783:web:90622d0cfb8f84eadbda02",
  measurementId: "G-26N4Z7TZ92"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app); // 🚨 Might break in SSR/Docker

// ✅ Export Firebase services
export { app, auth, googleProvider, analytics };
